/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
        
import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Wolf(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/wolf.gltf')
  const { actions } = useAnimations(animations, group)
  return (
    <group ref={group} {...props} dispose={null}>
      <primitive object={nodes.Body} />
      <primitive object={nodes.Tail_Control} />
      <primitive object={nodes.Bone034} />
      <primitive object={nodes.Bone035} />
      <primitive object={nodes.Bone036} />
      <primitive object={nodes.Bone037} />
      <skinnedMesh geometry={nodes.Cube004.geometry} material={materials.Upper} skeleton={nodes.Cube004.skeleton} />
      <skinnedMesh geometry={nodes.Cube004_1.geometry} material={materials.Down} skeleton={nodes.Cube004_1.skeleton} />
      <skinnedMesh geometry={nodes.Cube004_2.geometry} material={materials['Nose-Black']} skeleton={nodes.Cube004_2.skeleton} />
      <skinnedMesh geometry={nodes.Cube004_3.geometry} material={materials.NoseLight} skeleton={nodes.Cube004_3.skeleton} />
      <skinnedMesh geometry={nodes.Cube004_4.geometry} material={materials.Mouth} skeleton={nodes.Cube004_4.skeleton} />
    </group>
  )
}